import type { BillingInterval, BillingPlan } from "../api/types";

/**
 * Prices are static copy, not API data (FLOW-700 D1). Stripe holds the
 * authoritative amounts; duplicating them here is deliberate so the picker
 * renders without a second round trip. Changing a price means changing this
 * table and the Stripe Price together.
 */
export const PLAN_COPY: Record<
  BillingPlan,
  { name: string; blurb: string; price: Record<BillingInterval, string> }
> = {
  personal: {
    name: "Personal",
    blurb: "1 seat, for solo use",
    price: { month: "$20 / month", year: "$190 / year" },
  },
  pro: {
    name: "Pro",
    blurb: "No seat minimum. Seats are billed as your team grows.",
    price: {
      month: "$50 / seat / month",
      year: "$43 / seat / month, billed annually",
    },
  },
};

/** The 14-day trial every new organization starts on (FLOW-824). Static copy, same rule as PLAN_COPY: TrialPolicy is the authority. */
export const TRIAL_COPY = {
  name: "Trial",
  price: "Free for 14 days",
  note: "2.0M tokens · 1 project · no card required",
  blurb: "Try Flowicity on a real project before you commit.",
};
